import { Pipe, PipeTransform } from '@angular/core';
import { isNullOrUndefined } from '../vl_util_functions/common-utils';

@Pipe({
  name: 'vlDate'
})
export class VlDatePipe implements PipeTransform {

  monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  transform(value: any, pipe?: string, args?: any): any {
    if(pipe && !isNullOrUndefined(pipe)) {
      return !!this[pipe as keyof typeof this] ? (this[pipe as keyof typeof this] as any)(value, args): value;
    }
    return value;
  }

  private viewDatefromModelDate(value: any, args?: any): any {
    if(isNullOrUndefined(value)) {
      return '-';
    }
    value = value.toString();
    return value.substring(6,8) + '/' + value.substring(4,6) + '/' + value.substring(2,4);
  }

  private viewYtdDatefromModelDate(value: any, args?: any): any {
    if(isNullOrUndefined(value)) {
      return '-';
    }
    value = value.toString();
    return '01/' + '01/' + value.substring(2,4);
  }

  private defaultComparsionData(value: any, args?: any): any {
    if(isNullOrUndefined(value)) {
      return '-';
    }
    if(args === 'default') {
      value = this.viewDatefromModelDate((parseInt(value) - 300).toString());
    }else {
      value = this.viewDatefromModelDate((parseInt(value) - 10000).toString());
    }
    return value;
  }

  private viewDateinModelFormat(value: any, format?: any){
    if(isNullOrUndefined(value)) {
      return '-';
    }
    value =  value.toString();
    const year = value.substring(0,4);
    const month = value.substring(4,6);
    const day = value.substring(6,8);
    const time = value.substring(8,10);
    const date = day + ' ' + this.monthNames[parseInt(month)-1] + ', ' + year +' ' + this.toAmPm(time);
    return date;
  }

  private toAmPm(time: number) {
    let ampmTime = time > 12 ? time - 12 : time
    let ampmStr = time >= 12 && time < 24  ? ':00 PM' : ':00 AM'
    return (ampmTime.toString().length == 1 ? '0' + ampmTime : ampmTime) + ampmStr
  }
}
